module.exports = [{"type":"hash","text":"請求內容"},{"type":"normal","text":"請求需要鑒權的接口必須包含以下信息：","children":[{"type":"normal","text":"請求頭帶上 X-BX-APIKEY 傳遞 API Key。"},{"type":"normal","text":"請求參數帶上 signature 使用簽名算法得出的簽名。"},{"type":"normal","text":"timestamp 作為您的請求的時間戳,單位是毫秒。服務器收到請求時會判斷請求中的時間戳，如果是5000毫秒之前發出的，則請求會被認為無效。這個時間空窗值可以通過發送可選參數recvWindow來定義。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/authentication/03_request_content.json
// module id = HVe5
// module chunks = 3